import { render, staticRenderFns } from "./LanguageProficiencyReadWrite.vue?vue&type=template&id=650555fb&"
import script from "./LanguageProficiencyReadWrite.vue?vue&type=script&lang=js&"
export * from "./LanguageProficiencyReadWrite.vue?vue&type=script&lang=js&"
import style0 from "./LanguageProficiencyReadWrite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports